import styles from './index.scss'
import { Form, Input, Button } from 'antd-mobile'
import React, { useRef, useState, useEffect } from 'react'
import Layout from '@/libs/components/Layout'

export default function Activate() {
  const [loading, setLoading] = useState(false)

  return (
    <Layout title="激活权益">
      <div className={styles.activatePage}>
        <div className={styles.container}>
          <Form
            layout="horizontal"
            footer={
              <Button
                block
                shape="rounded"
                loading={loading}
                type="submit"
                color="primary"
                size="middle"
              >
                确定
              </Button>
            }
          >
            <Form.Item
              name="name"
              rules={[{ required: true, message: '请输入激活码' }]}
            >
              <Input onChange={console.log} placeholder="请输入激活码" />
            </Form.Item>
          </Form>
        </div>
      </div>
    </Layout>
  )
}
